import { render, staticRenderFns } from "./CodeAndContact.vue?vue&type=template&id=b062366a&scoped=true&"
import script from "./CodeAndContact.vue?vue&type=script&lang=js&"
export * from "./CodeAndContact.vue?vue&type=script&lang=js&"
import style0 from "./CodeAndContact.vue?vue&type=style&index=0&id=b062366a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b062366a",
  null
  
)

export default component.exports